import { autoinject } from 'aurelia-framework';

class MatchablePassphrase {

    public matched = false;

    protected index = 0;

    constructor(protected readonly passphrase: string) { }

    public matchNext(str: string) {
        Array.from(str).forEach((char) => {
            this.index %= this.passphrase.length;
            this.index = this.passphrase[this.index] === char ? this.index + 1 : 0;
            this.matched = this.index === this.passphrase.length;
        });
        return this.index > 0;
    }

    public toString() { return this.passphrase; }
}


@autoinject()
export class PassphraseService {

    protected subscriptions: Map<string, { passphrase: MatchablePassphrase, handlers: Function[] }> = new Map();

    constructor() {
        document.body.addEventListener('keydown', (event: KeyboardEvent) => {
            this.subscriptions.forEach(({ passphrase, handlers }) => {
                if(!event?.key) { return; }
                passphrase.matchNext(event.key);
                if(passphrase.matched) {
                    handlers.forEach((handler) => handler());
                }
            })
        }, { capture: true });
    }

    public registerPassphrase(passphrase: string, handler: Function) {
        let subscription = this.subscriptions.get(passphrase);
        if(subscription === undefined) {
            this.subscriptions.set(passphrase, subscription = {
                passphrase: new MatchablePassphrase(passphrase),
                handlers: [handler]
            });
        } else {
            subscription.handlers.push(handler);
        }
    }

    public deregisterPassphrase(passphrase: string, handler?: Function) {
        const subscription = this.subscriptions.get(passphrase);
        if(subscription && handler) {
            subscription.handlers = subscription.handlers.filter((h) => handler !== h);
        }
        if(handler === undefined || subscription?.handlers.length === 0) {
            this.subscriptions.delete(passphrase);
        }
    }

}
